import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers, URLSearchParams, ResponseContentType } from '@angular/http';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { Observable } from 'rxjs/Observable';
import { Contact } from '../model/conversationContacts';
import { ConversationContacts, ConversationContact, Conversations,
  Conversation, Attachment, ConversationMarginal } from '../model/conversationContacts';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { environment } from '../../../../environments/environment';
import * as ServerObj from '../model/serverObjects';
import { ExceptionService } from 'app/common/service/exception.service';
import { MessagePayload } from '../model/serverObjects';
import { WindowRefService } from 'app/common/service/window-ref.service';

@Injectable()
export class ClmtlkService {

  private window: Window;
  private strFKScenario: string;
  public deletedConversations:Conversation;
  public conversation:Conversation;
  url: any = {
    STREAM_CONTACT: environment.CLMTLK_WS_BASE_URL + `autocompleteContacts`,
    INBOX_VIEW: environment.CLMTLK_WS_BASE_URL + `?view=overview`,
    THREAD_VIEW: environment.CLMTLK_WS_BASE_URL + `?view=conversations`,
    NEW_MESSAGE_POST: environment.CLMTLK_WS_BASE_URL + 'conversations',
    CONVERSATION_CONTACT_POST: environment.CLMTLK_WS_BASE_URL + 'conversationContacts',
    DOWNLOAD_ATTACHMENT: environment.CLMTLK_WS_BASE_URL + 'attachments',
    GET_HEADER_CONTENT: environment.CLMTLK_WS_BASE_URL + 'marginals',
    GET_USER_SIGNATURE: environment.CLMTLK_WS_BASE_URL + 'userProfile'
  };


  constructor(private http: Http,
    private clmtlkSessionService: ClmtlkSessionService,
    private exceptionService: ExceptionService,
    private windowService: WindowRefService){
      this.window = windowService.nativeWindow;
  }




  /**
   * // 'mockdata/contacts'
   * // this.url.STREAM_CONTACT
   */
  getContactList() {

    return <Observable<ConversationContact[]>>
      this.http.get(this.url.STREAM_CONTACT, this.getOptions())
        .map(response => this.extract<{conversationContacts: ConversationContacts}>(response))
        .map((response: { conversationContacts: ConversationContacts}): ConversationContact[] => {
            return response.conversationContacts && response.conversationContacts.conversationContact || [];
        })
        .map(result => {

          //<!-- REMOVE SMS OPTION -->
          let contacts :ConversationContact[] = [];
          if(result == null || result.length < 1){
            this.clmtlkSessionService.streamContacts = result;
            return result;
          }

          result.forEach(contact => {
              //if (contact.contacts.contact[0].CTC_TYP_CD === 'email')
              {
                contacts.push(contact);
              }
          });

          this.clmtlkSessionService.streamContacts = contacts;
          return contacts;


          // this.clmtlkSessionService.streamContacts = result;
          // return result;
         })
        .catch(err => this.exceptionService.handleError(err))
        .filter(val => val != null)
        .finally(() => {
        });
  }


  initializeMainData() {

    // If header are loaded already, then skip reloading them again
    if (this.clmtlkSessionService.isInitialized) {
      return this.getInboxData();
    }

    return this.getHeaderContent()
      .flatMap(result =>  this.getInboxData())
      .catch(error => {
        return Observable.throw(error);
      });

  }

    // FORK JOIN
    //   return Observable.forkJoin(
    //   this.getInboxData(),
    //   this.getContactList()
    // ).map(result => {
    //   this.clmtlkSessionService.streamContacts = result[1];
    //   return result[0];
    // }).catch(error => {
    //   return Observable.throw(error);
    // });


  getFKScenario(){
    return this.strFKScenario;
  }
  /**
   *  Get Inbox Grid Data
   * //   mockdata/inboxStNewConv
   * //  'mockdata/inboxViewLatest'
   * // this.url.INBOX_VIEW
   */
  getInboxData() {
    const params: URLSearchParams = new URLSearchParams();
     params.set('v', new Date().getTime().toString());

     return <Observable<ConversationContact[]>>
      this.http.get(this.url.INBOX_VIEW, this.getOptions(params))
        .map(response => this.extract<ServerObj.Root>(response))
        .map((response: ServerObj.Root): ConversationContact[] => {
          console.info("response.Response.Results",response);
          // for non Stream User open the last conversation
          this.strFKScenario = response.Request["strFKScenario"];
          this.clmtlkSessionService.setFKScenario(response.Request["strFKScenario"]);
          if(this.strFKScenario=="threaddetails"){
            this.conversation = response.Response.Results.conversations.conversation;
            console.info("strFKScenario",this.clmtlkSessionService.getFKScenario());
            var threadMessage = response.Response.Results.conversations.conversation[0].conversationThreads.conversationThread[0].threads.thread[0].threadMessages.threadMessage[0];
            console.info("threadMessage",threadMessage);
            console.info("threadMessage.messages.message[0].conversationContacts.conversationContact",threadMessage.messages.message[0].conversationContacts.conversationContact);
            return threadMessage.messages.message[0].conversationContacts.conversationContact;
          }
          // non-Stream User end
          // Purged messages
          //console.info(response.Response.Results.conversationContacts.conversationContact[0].loggedInConversationContacts)
          if(response.Response.Results.conversationContacts.conversationContact[0].loggedInConversationContacts){
            var loggedInConversationContacts = response.Response.Results.conversationContacts.conversationContact[0].loggedInConversationContacts;
            //console.info("loggedInConversationContacts",loggedInConversationContacts)
            //console.info("deletedConversations",loggedInConversationContacts.conversationContact[0].deletedConversations)
            if(loggedInConversationContacts.conversationContact[0].deletedConversations){
              this.deletedConversations=loggedInConversationContacts.conversationContact[0].deletedConversations.conversation;
            }
          }
          // purged messages end
          return response.Response.Results.conversationContacts.conversationContact;
        })
        .catch(err => this.exceptionService.handleError(err))
        .filter(val => val != null)
        .finally(() => {
        });
  }

  /**
   * Update the Conversation with Mark as read
   *   // inmemory
   *  // this.http.get('mockdata/inboxViewLatest', this.getOptions())
   *  // this.http.post(this.url.CONVERSATION_CONTACT_POST, payload, this.getOptions())
   *
   */
  postConversationContact(payload: { conversationContacts: ConversationContacts }) {
    return <Observable<ConversationContact[]>>
        this.http.post(this.url.CONVERSATION_CONTACT_POST, payload, this.getOptions())
        .map(response => this.extract<ServerObj.Root>(response))
        .map((response: ServerObj.Root): ConversationContact[] => {
          return response.Response.Results.conversationContacts.conversationContact;
        }).catch(err => this.exceptionService.handleError(err))
        .filter(val => val != null)
        .finally(() => {
        });
  }



  /**
   * Get Thread messages Data
   * // mockdata/threadDetail
   * // this.url.THREAD_VIEW
   */
  getThreadDetails(conv_id, thrd_id) {

     const params: URLSearchParams = new URLSearchParams();
     params.set('convId', conv_id);
     params.set('thrdId', thrd_id);
     params.set('v', new Date().getTime().toString());

    // this.http.get('mockdata/threadDetail')
    // this.http.get(this.url.THREAD_VIEW, this.getOptions(params))
     // Inmemory
    return <Observable<Conversation>>
      this.http.get(this.url.THREAD_VIEW, this.getOptions(params))
        .map(response => this.extract<ServerObj.Root>(response))
        .map((response: ServerObj.Root): Conversation => {
            return response.Response.Results.conversations.conversation[0];
        })
        .catch(err => this.exceptionService.handleError(err))
        .filter(val => val != null)
        .finally(() => {
        });
  }


  dowloadFile(attachment: Attachment) {

    const params: URLSearchParams = new URLSearchParams();
    params.set('id', attachment.ATTCH_ID.toString());


    return <Observable<Blob>>
    this.http.get(this.url.DOWNLOAD_ATTACHMENT, this.getOptions(params, null, ResponseContentType.Blob))
      .map(response =>  this.extract<Blob>(response))
      .catch(err => this.exceptionService.handleError(err))
      .filter(val => val != null)
      .finally(() => {
      });
  }


  getHeaderContent() {
    return <Observable<ConversationMarginal[]>>
    this.http.get(this.url.GET_HEADER_CONTENT, this.getOptions())
    .map(response => this.extract<ServerObj.Root>(response))
    .map((response: ServerObj.Root): ConversationMarginal[] => {
          return response.Response.Results.conversationMarginals.conversationMarginal;
    })
    .map(result => {
      this.clmtlkSessionService.isInitialized = true;
      this.clmtlkSessionService.headerTemplate = result;
      return result;
    })
    .catch(err => this.exceptionService.handleError(err))
    .filter(val => val != null)
    .finally(() => {
    });
  }


  /**
   * Create new Message. which includes contact lists , Message, attachements
   * // mockdata/messagePostResponse
   * // this.url.NEW_MESSAGE_POST
   *
   * //  Inmemory
   * // this.http.get('mockdata/messagePostResponse', this.getOptions())
   * // this.http.post(this.url.NEW_MESSAGE_POST, payload, this.getOptions())
   */
  postConversation(payload: MessagePayload) {

    const formData: FormData = new FormData();
    formData.append('payload', new Blob([JSON.stringify(payload.root)],{type : 'application/json'}), 'payload');
    if (payload.attachments && payload.attachments.length > 0) {
      payload.attachments.forEach(file => {
          formData.append('files', file, file.name);
      });
    }

    return <Observable<Conversation>>
      this.http.post(this.url.NEW_MESSAGE_POST, formData, this.getOptions(null, 'skip'))
        .map(response => this.extract<ServerObj.Root>(response))
        .map((response: ServerObj.Root): Conversation => {
            return response.Response.Results.conversations.conversation[0];
        })
        .catch(err => this.exceptionService.handleError(err))
        .filter(val => val != null)
        .finally(() => {
        });
  }

  getStreamUserSignature() {

    return <Observable<string>>
    this.http.post(this.url.GET_USER_SIGNATURE, this.clmtlkSessionService.loggedInContact.contacts, this.getOptions())
      .map(response => this.extract<any>(response))
      .map(response => {
          this.clmtlkSessionService.userSignature = response &&
              response.users[0] &&
              response.users[0].claimsTalkSignature || '';
          return this.clmtlkSessionService.userSignature;
      })
      .catch(err => this.exceptionService.handleError(err))
      .filter(val => val != null)
      .finally(() => {
      });
  }

  private extract<T>(res: Response) {
    try {

      if (res.status < 200 || res.status >= 300) {
        throw new Error('Bad response status: ' + res.status);
      }
      const body = res.json ? res.json() : res;

      const root: ServerObj.Root = body && body.Root || body.data && body.data.Root;
      if (root && root.Error && root.Error.ErrorMessage &&
        root.Error.ErrorMessage !== '' && !root.Error.ErrorMessage['xsi:nil']) {
        throw new Error('Server Error: ' + root.Error.ErrorMessage);
      }

      if (root) {

        if (body && body.Root) {
          return body.Root;
        }else if (body && body.data.Root) {
          return body.data.Root;
        }
      } else {

        return body.data ? <T>body.data : <T>body;
      }

      // Inmemory
      // return root ? <T>(body && body.data.Root) : <T>body.data;
      // return root ? <T>(body && body.Root) : <T>body;

    } catch (error) {
      throw new Error('Response Parse Error: ' + error);
    }

  }

  private getOptions(params?: URLSearchParams, contentType?: string, responseType?: ResponseContentType): RequestOptions {
    const requestOptions: RequestOptions = new RequestOptions();

    // Header
    const headers: Headers = new Headers(
          {
            'Authorization': 'Bearer ' + this.clmtlkSessionService.authToken,
            // 'ContactID': this.clmtlkSessionService.loggedInContact ? this.clmtlkSessionService.loggedInContact.CTC_ID : '',
            'Access-Control-Allow-Origin': '*',
            'X-Skip-Overview': this.clmtlkSessionService.getSkipOverview()
          });

    console.info("this.clmtlkSessionService",this.clmtlkSessionService,"headers",headers)
    if (!contentType) {
      headers.append('Content-Type', 'application/json');

    }else if (contentType && contentType !== 'skip') {
        headers.append('Content-Type', contentType);
    }

    if (this.clmtlkSessionService.pinCode &&
      this.clmtlkSessionService.pinCode !== null) {
        headers.append('X-Security-Pin', this.clmtlkSessionService.pinCode);
    }

    if (this.clmtlkSessionService.srcId &&
      this.clmtlkSessionService.srcId !== null) {
        headers.append('X-Src-Id', this.clmtlkSessionService.srcId);
    }

    requestOptions.headers = headers;

    // Params
    if (params) {
      requestOptions.params = params;
    }

    // Response Type
    if (responseType) {
      requestOptions.responseType = responseType;
    }

    return requestOptions;
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/service/clmtlk.service.ts